import {getBuildFields} from '../../../rest/builds'
import type {GetBuildApiArg} from '../../../services/rest'

const artifactDependencyChangesFields = `artifactDependencyChanges(buildChange($locator(count:100),nextBuild(${getBuildFields()})))`

export const getBuildArtifactDependenciesChangesArg = (buildLocator: string): GetBuildApiArg => ({
  buildLocator,
  fields: artifactDependencyChangesFields,
})
